import { Box, Text } from 'ink';
import Link from 'ink-link';

export default function Footer({
  hasBuildEverFailed,
  shouldShowCancelBuildInstructions,
  uiUrl,
}: {
  hasBuildEverFailed?: boolean;
  shouldShowCancelBuildInstructions?: boolean;
  uiUrl?: string;
}) {
  if (!uiUrl) {
    return null;
  }

  let buildFailedMessage;
  if (hasBuildEverFailed) {
    buildFailedMessage = <Text color="red">An error has occurred. </Text>;
  }

  return (
    <Box flexDirection="column">
      <Box flexDirection="column">
        <Text bold>{buildFailedMessage}See web UI for more information: </Text>
        <Text>
          <Link fallback={false} url={uiUrl}>
            {uiUrl}
          </Link>
        </Text>
      </Box>
      {shouldShowCancelBuildInstructions ? (
        <Text color="gray">
          <Text bold>[esc]:</Text> cancel build
        </Text>
      ) : null}
    </Box>
  );
}
